import { useEffect } from 'react';

import { useActiveSeason } from '@features/seasonal-theme/hooks/use-active-season';
import { SEASON_ICONS, svgToDataUri } from '@features/seasonal-theme/utils/season-icons';

// Tokens shadcn/Tailwind pilotés par la saison (équivalent de `useSeasonalThemeOverrides` côté MUI).
const TOKENS = ['--primary', '--primary-foreground', '--season-icon', '--season-decoration'] as const;

export const useSeasonalCssVariables = () => {
  const { season } = useActiveSeason();

  useEffect(() => {
    const root = document.documentElement;
    const { style } = root;

    if (!season) {
      TOKENS.forEach((token) => style.removeProperty(token));
      root.removeAttribute('data-season');
      return undefined;
    }

    const { main, contrastText } = season.palette.primary;
    style.setProperty('--primary', main);
    style.setProperty('--primary-foreground', contrastText);
    // Logo decoration (`.logo-season::after` in tailwind.css)
    style.setProperty('--season-icon', svgToDataUri(SEASON_ICONS[season.id]));
    style.setProperty('--season-decoration', season.decorationColor ?? main);
    root.setAttribute('data-season', season.id);

    return () => {
      TOKENS.forEach((token) => style.removeProperty(token));
      root.removeAttribute('data-season');
    };
  }, [season]);
};
